import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from 'common/components/Label';

import styles from './index.module.css';

const TextAreaLabel = ({
  disabled,
  hideLabel,
  id,
  labelText,
  optionalLabel,
  required,
}) => {
  const labelClasses = classNames(styles.label, {
    [styles.required]: required,
    [styles.visuallyHidden]: hideLabel,
  });

  return (
    <div className={labelClasses} required={required}>
      {labelText && (
        <Label for={id} disabled={disabled} labelType="main">
          {labelText}
          {optionalLabel && (
            <span className={styles.optional}>{` (optional)`}</span>
          )}
        </Label>
      )}
    </div>
  );
};

TextAreaLabel.propTypes = {
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  optionalLabel: PropTypes.bool,
  required: PropTypes.bool,
};

TextAreaLabel.defaultProps = {
  disabled: false,
  hideLabel: false,
  labelText: '',
  optionalLabel: false,
  required: false,
};
export default TextAreaLabel;
